import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import About from '../components/About/About'
import Facts from '../components/About/Facts'
import Service from '../components/Services/Service'
import Feature from '../components/Services/Feature'
import Contact from '../components/Contactus/Contact'
import Team from '../components/Team/Team'
import Testonomial from '../components/Testonomial/Testonomial'
import Footer from '../components/Footer/Footer'
import Banner from '../components/Banner/Banner'
import SplideServices from '../components/Services/SplideServices'

const MainPage = () => {
  return (
    <div>
    <body>
    <Navbar/>
    <Banner/>
    <About showButton={true} />
    <Facts/>
   <Service/>
  <Feature/>
  <Contact/>
  <SplideServices/>
  {/* <Team/> */}
  {/* <Testonomial/> */}
  <Footer/>
</body>
</div>
  )
}

export default MainPage